import { useState } from 'react';
import classes from './TextBtn.module.scss';

const TextBtn = (props) => {
	const LeftIcon = props.leftIcon;
	const RightIcon = props.rightIcon;

	return (
		<>
			{!props.disabled ? (
				<button
					id={props.id}
					className={[classes.main, props.className].join(' ')}
					style={props.style}
					onClick={() => {
						if (props.onClick) {
							props.onClick();
						}
					}}
				>
					{props.leftIcon && <LeftIcon className={classes.icon} />}
					<span className={classes.text}>{props.text}</span>
					{props.rightIcon && <RightIcon className={classes.icon} />}
				</button>
			) : (
				<button id={props.id} className={classes.disabled}>
					<span className={classes.disabledText}>{props.text}</span>
				</button>
			)}
		</>
	);
};

export default TextBtn;
